import Resolver from '@spotify-internal/remote-config-resolver';

import oauth from '../oauth/oauth';

// eslint-disable-next-line import/no-webpack-loader-syntax
import properties from '!json-loader!yaml-loader!../../../etc/properties.yaml';

// Instantiate the library
const resolver = new Resolver({
  clientId: 'support-site-frontend',
  properties,
  getToken: cb => cb([oauth.getToken()]),
  timeout: 1000,
});

const overrides = new URLSearchParams(window && window.location ? window.location.search : '');

// Edgecases while we migrate the chatbot: cb=experiment gives prod bot, =experiment_test gives shared
if (overrides.get('cb') === 'experiment') {
  overrides.set('chatbot_test', 'true');
  overrides.delete('cb');
} else if (overrides.get('cb') === 'experiment_test') {
  overrides.set('chatbot_test', 'true');
  overrides.set('chatbot_test_shared', 'true');
  overrides.delete('cb');
}

// Override the resolver to also contain these overrides (to be used inside of withExperimentation)
resolver.overrides = overrides;

export default resolver;
